import { formatDateTime, ItemListContent, userInteraction } from "@eusoft/webapp-framework";
import { formatText, MaterialIcon } from "@eusoft/webapp-ui";
import { navigatePage } from "../../actions/Common";
import { DeviceType, SortDirection, type Guid, type IDeviceListView, type IListDevice } from "../../entities/Commands";
import { Icons } from "../../entities/Icons";
import { formatDeviceType } from "../../helpers/Format";
import { entityItemsSource } from "../../helpers/ItemsSources";
import { Authorize } from "../../services/Authorize";
import { executeAsync } from "../../services/DataService";

export interface IListDeviceArgs {
}

export async function closeAllSessionsAsync(deviceId: Guid) {

    const sessions = await executeAsync("ListSession", {
        onlyActive: true,
        deviceId
    });

    if (sessions.items.length == 0) {
        userInteraction.messageAsync(formatText("msg-no-active-session"), "warning", 3000);
        return;
    }

    if (!await userInteraction.confirmAsync(formatText("msg-confirm-close-sessions", sessions.items.length), "confirm"))
        return;


    for (const session of sessions.items)
        await executeAsync("CloseSession", { sessionId: session.id });   

    userInteraction.messageAsync(formatText("msg-operation-completed"), "success", 3000);
}   

export const ListDevicePage = ItemListContent.builder<IDeviceListView, IListDevice>() 

    .info({
        name: "device-list",
        route: "/devices",
        icon: Icons["device"]
    })

    .feature(Authorize(bld => bld.resource("Device", "list")))

    .action({
        name: "delegate",
        text:  "delegate-device",
        priority: "primary",
        executeAsync: () => navigatePage("delegate-device"),
        type: "global"
    })

    .options({
        title: "device-list",
        style: ["panel", "round-item"],
        itemsSource: {
            ...entityItemsSource("ListDevice"),
            getIcon: item => {
                if (item.type == DeviceType.Android)
                    return <MaterialIcon style="green" name="android"/>
            }
        },
        prepareFilter: (filter, offset, limit) => ({
            ...filter,
            onlyActive: true,
            pagination: {
                offset,
                limit
            },
            sort: {
                property: "LastAccessTime",
                direction: SortDirection.Descending
            }
        }),
        itemView: item => ({
            maxActions: 0,
            style: ["round-icon"],
        }), 
        itemActions: (item, res) => {

            res.push({
                name: "close-sessions",
                text: "close-sessions",
                type: "global", 
                priority: "secondary",
                icon: <MaterialIcon name="logout" />,
                executeAsync: () => closeAllSessionsAsync(item.id)
            });
        }, 
        pageSize: 50,
        columns: [{
            value: a => a.name,
            priority: "primary",
            header: "name", 
        }, {
            value: a => formatDeviceType(a.type),
            priority: "secondary",
            header: "type",
        }, {
            value: a => formatDateTime(a.lastAccessTime),
            priority: "secondary",
            header: "last-access",
        }, {
            value: a => a.info?.brand + " " + a.info?.model,
            priority: "secondary",
            header: "model",
        }],
        filterMode: "tags"

    })
    .asContent();